import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AccountService } from "../../../services/account.service";
import { APP_SETTINGS, SCAMP_API } from "src/environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class MaterialService {
  constructor(private http: HttpClient, private account: AccountService) {}

  create(data: any) {
    return this.http.post(`${SCAMP_API.accountApiV1}/material`, data, {
      headers: this.account.composeHeaders(),
    });
  }

  read(id: number): Observable<any> {
    return this.http.get<any>(`${SCAMP_API.accountApiV1}/material/${id}`, {
      headers: this.account.composeHeaders(),
    });
  }

  update(id: number, data: any) {
    return this.http.put(`${SCAMP_API.accountApiV1}/material/${id}`, data, {
      headers: this.account.composeHeaders(),
    });
  }

  delete(id: number) {
    return this.http.delete(`${SCAMP_API.accountApiV1}/material/${id}`, {
      headers: this.account.composeHeaders(),
    });
  }

  getMateriais(): Observable<any[]> {
    return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/materiais`, {
      headers: this.account.composeHeaders(),
    });
  }

  getUltimasEntradasMaterias(materialId): Observable<any[]> {
    return this.http.get<any[]>(
      `${SCAMP_API.accountApiV1}/materiais/ultimas-entrdas/${materialId}/${APP_SETTINGS.numeroUltimasEntradasAExibir}`,
      {
        headers: this.account.composeHeaders(),
      }
    );
  }

  isUniqueDescricaoMaterial(
    descricao: string,
    id: number
  ): Observable<boolean> {
    return this.http.post<boolean>(
      `${SCAMP_API.accountApiV1}/descricao-material-is-unique`,
      { descricao, id },
      { headers: this.account.composeHeaders() }
    );
  }

  isUniqueCodigoMaterial(codigo: string, id: number): Observable<boolean> {
    return this.http.post<boolean>(
      `${SCAMP_API.accountApiV1}/codigo-material-is-unique`,
      { codigo, id },
      { headers: this.account.composeHeaders() }
    );
  }

  isUniqueNCMMaterial(ncm: string, id: number): Observable<boolean> {
    return this.http.post<boolean>(
      `${SCAMP_API.accountApiV1}/ncm-is-unique`,
      { ncm, id },
      { headers: this.account.composeHeaders() }
    );
  }

  search(parametro: string): Observable<any[]> {
    return this.http.post<any[]>(
      `${SCAMP_API.accountApiV1}/materiais-search`,
      { descricao: parametro },
      { headers: this.account.composeHeaders() }
    );
  }

  exportarToExcel(parametro: string): Observable<any> {
    return this.http.post<any>(
      `${SCAMP_API.accountApiV1}/materiais/exportar-excel`,
      { descricao: parametro },
      { headers: this.account.composeHeaders() }
    );
  }

  getNextId(): Observable<any> {
    return this.http.get<any>(
      `${SCAMP_API.accountApiV1}/materiais/next-codigo`,
      { headers: this.account.composeHeaders() }
    );
  }
}
